import {
  CancelDialogActions,
  ImageCancelDialogLayout,
  CancelModal,
  CancelDialogMessageLayout,
} from '@Components/shared/dialogs/CancelDialog';
import { useCreateRoundConfig } from '@Modal/hooks/rounds/useCreateRoundConfig';

export const CreateRoundConfigCancelModalDialog: React.FC = () => {
  const { handleCancelTakeMeBack, showCancelRoundConfigForm } = useCreateRoundConfig();

  return (
    <>
      {showCancelRoundConfigForm && (
        <CancelModal open={showCancelRoundConfigForm}>
          <ImageCancelDialogLayout
            title="Cancel vehicle changes?"
            actions={
              <CancelDialogActions
                onReject={() => handleCancelTakeMeBack('back')}
                onConfirm={() => handleCancelTakeMeBack('')}
              />
            }
          >
            <CancelDialogMessageLayout>
              You are about to delete all the changes you have made in round config settings
            </CancelDialogMessageLayout>
          </ImageCancelDialogLayout>
        </CancelModal>
      )}
    </>
  );
};
